import React from 'react'
import { URLAction, useURLParams } from '../../providers/URLParams'
import { FeedbackModal } from './feedback'
import { AppState, useAppContext } from '../../providers/context'
import { AbbreviationConfigModal } from './abbreviationSettings'
import { AttendanceSettingsModal } from './attendanceSettings'
import { CallerIDConfigModal } from './callerIdConfig'
import { DistrictSettingsModal } from './districtSettings'
import { EditUserModal } from './editUser'
import { GeneralLexikeetCallModal } from './generalLexikeetCall'
import { UnreadSystemMessageModal } from './systemMessage'
import { clearShownRecently } from '../../utils'

export const AppModals: React.FC = () => {
  const { state, setState } = useAppContext()
  const user = state.user

  const [showFeedbackModal, setShowFeedbackModal] = React.useState(false)
  const [showGeneralLexikeetCall, setShowGeneralLexikeetCall] = React.useState(false)
  const [showAttendanceSettingsModal, setShowAttendanceSettingsModal] = React.useState(false)
  const [showDistrictSettingsModal, setShowDistrictSettingsModal] = React.useState(false)
  const [showCallerIDConfigModal, setShowCallerIDConfigModal] = React.useState(false)
  const [showAbbreviationConfigModal, setShowAbbreviationConfigModal] = React.useState(false)
  const [showEditUserModal, setShowEditUserModal] = React.useState(false)

  const URLParams = useURLParams()
  React.useEffect(() => {
    if (URLParams.pop(URLAction.OpenFeedback)) setShowFeedbackModal(true)
    if (URLParams.pop(URLAction.OpenGeneralLexikeetCall)) setShowGeneralLexikeetCall(true)
    if (URLParams.pop(URLAction.OpenAttendanceSettings)) setShowAttendanceSettingsModal(true)
    if (URLParams.pop(URLAction.OpenDistrictSettings)) setShowDistrictSettingsModal(true)
    if (URLParams.pop(URLAction.OpenCallerIDConfig)) setShowCallerIDConfigModal(true)
    if (URLParams.pop(URLAction.OpenAbbreviationConfig)) setShowAbbreviationConfigModal(true)
    if (URLParams.pop(URLAction.OpenEditUser)) setShowEditUserModal(true)
    // this is a inperfect way to test the onboarding modals. Since it doesnt actually reset the users state, it will only
    // work until the user is reloaded. For example if you press save on the updatedContactsModal it will skip the rest after reloading the user
    if (URLParams.pop('__testOnboardingModals__' as URLAction) === 'all') setupFakeOnboarding(setState)
  }, [URLParams])

  return (
    <>
      {showFeedbackModal && <FeedbackModal onClose={() => setShowFeedbackModal(false)} />}
      {!!user?.unreadSystemMessages?.length && <UnreadSystemMessageModal messages={user.unreadSystemMessages} />}
      {showGeneralLexikeetCall && <GeneralLexikeetCallModal onClose={() => setShowGeneralLexikeetCall(false)} />}
      {showAttendanceSettingsModal && user?.type === 'teacher' && (
        <AttendanceSettingsModal user={user} onClose={() => setShowAttendanceSettingsModal(false)} />
      )}
      {showDistrictSettingsModal && user?.type === 'teacher' && (
        <DistrictSettingsModal user={user} onClose={() => setShowDistrictSettingsModal(false)} />
      )}
      {showCallerIDConfigModal && user?.type === 'teacher' && (
        <CallerIDConfigModal user={user} onClose={() => setShowCallerIDConfigModal(false)} />
      )}
      {showAbbreviationConfigModal && user?.type === 'teacher' && (
        <AbbreviationConfigModal user={user} onClose={() => setShowAbbreviationConfigModal(false)} />
      )}
      {showEditUserModal && user && <EditUserModal user={user} onClose={() => setShowEditUserModal(false)} />}
    </>
  )
}

const setupFakeOnboarding = (setState: React.Dispatch<React.SetStateAction<AppState>>) =>
  setTimeout(
    // wait 1s for the user to be all loaded
    () => {
      // clear the shown recently modals for modals that only show once an hour
      for (const key of ['outOfOfficeModal', 'teacherTypeModal']) clearShownRecently(key)
      setState((s) => ({
        ...s,
        user: s.user && {
          ...s.user,
          outOfOffice: s.user.type !== 'teacher' ? undefined : 'This is a test out of office message',
          unreadSystemMessages: [
            { subject: 'Subjet', content: 'AAAA <br/> <b>new line</b>', id: 1 },
            {
              subject: 'The system message subject',
              content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).Where does it come from?Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
              id: 2,
            },
          ],
          requestUpdatedContacts: {
            email: s.user.type === 'guardian' ? 'ee@bb.com' : undefined,
            phoneNumber: '123',
          },
          newYear:
            s.user.type !== 'teacher'
              ? undefined
              : {
                  suggestDeletingClasses: [
                    {
                      name: 'Class1',
                      id: -1,
                      otherTeachersCount: 10,
                      studentsCount: 5,
                    },
                    {
                      name: 'Class2',
                      id: -2,
                      otherTeachersCount: 0,
                      studentsCount: 50,
                    },
                  ],
                },
          requestTeacherType: s.user.type === 'teacher',
          showTutorial: true,
        },
      }))
    },
    1000
  )
